import { Clock, Loader2 } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "~/components/ui/button";
import { trackEvent } from "~/utils/analytics";

interface GenerateChronologyViewProps {
  onGenerate: () => void;
  isGenerating: boolean;
}

export const GenerateChronologyView: FC<GenerateChronologyViewProps> = ({
  onGenerate,
  isGenerating,
}) => (
  <div className="px-3 flex items-center justify-center h-full">
    <div className="py-8">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <div className="text-xs text-muted-foreground">
            <FormattedMessage
              id="chronology.generate.label"
              defaultMessage="Generate Chronology"
            />
          </div>
          <h2 className="text-lg font-semibold normal-case">
            <FormattedMessage
              id="chronology.generate.title"
              defaultMessage="Case Chronology"
            />
          </h2>
          <p className="text-sm text-muted-foreground">
            <FormattedMessage
              id="chronology.generate.description"
              defaultMessage="A date-sorted chronology of key events extracted from your case documents — medical visits, surgeries, accidents, and more."
            />
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            {isGenerating ? (
              <Button disabled>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                <FormattedMessage
                  id="chronology.generate.generating"
                  defaultMessage="Generating..."
                />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => {
                    trackEvent({
                      eventName: "app/chronology/generate.button/click",
                    });
                    onGenerate();
                  }}
                >
                  <FormattedMessage
                    id="chronology.generate.button"
                    defaultMessage="Generate"
                  />
                </Button>
                <div className="flex items-center gap-1">
                  <Clock className="h-3 w-3 text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    <FormattedMessage
                      id="chronology.generate.time"
                      defaultMessage="~3 min"
                    />
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
